import React from 'react';
import { Box, Grid, Paper, Tab, Tabs } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import PageHeader from '../../../components/page-header';
import { FormPageFooter } from '../../../components/form-page-parts';
import IrpItemDataTable from './components/irp-item-data-table';
import IrpFileDataTable from './components/irp-file-data-table';
import { IrpGeneralForm } from './components/irp-general-form';
import { useIrpCreateEditController } from './context/irp-create-edit-controller';
import { useIrpCreateEditState } from './context/irp-create-edit-context';
import { validateIrp } from './context/irp-validation';

const TAB_GENERAL = 0;
const TAB_ITEMS = 1;
const TAB_FILES = 2;

export function IrpCreateEditComponent() {
    const ctrl = useIrpCreateEditController();
    const { file, tabIndex1, irpRequest, irpId, showValidationErrors, itemsIrpJson } = useIrpCreateEditState();
    const errors = showValidationErrors ? validateIrp(irpRequest, { isEdit: ctrl.isEdit, hasFile: !!file }) : {};

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title={ctrl.isEdit ? 'Editar Intenção de Registro de Preço' : 'Nova Intenção de Registro de Preço'}
                    subtitle={ctrl.isEdit ? 'Atualize as informações da intenção de registro de preço' : 'Cadastre uma nova intenção de registro de preço'}
                    breadcrumbs={[
                        { label: 'Intenção de Registro de Preço', href: '/intencao-registro-preco' },
                        { label: ctrl.isEdit ? 'Editar' : 'Nova' },
                    ]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column' }} elevation={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Tabs value={tabIndex1} onChange={ctrl.handleTabChange}>
                            <Tab label="Dados da IRP" />
                            <Tab label="Itens" />
                            {ctrl.isEdit && <Tab label="Arquivos" />}
                        </Tabs>

                        <Box sx={{ height: tabIndex1 !== TAB_GENERAL ? '600px' : 'auto', display: 'flex', flexDirection: 'column' }}>
                            {tabIndex1 === TAB_GENERAL && (
                                <IrpGeneralForm errors={errors} onChange={ctrl.handleOnChange} onDateChange={ctrl.handleDateChange} onFileChange={ctrl.setFileUpload} />
                            )}
                            {tabIndex1 === TAB_ITEMS && (
                                <IrpItemDataTable
                                    irpId={irpId?.toString()}
                                    modalityId={irpRequest.modalityId}
                                    itemsIrpJson={itemsIrpJson}
                                    setItemsIrpJson={ctrl.setItemsIrpJson}
                                />
                            )}
                            {tabIndex1 === TAB_FILES && <IrpFileDataTable irpId={irpId?.toString()} />}
                        </Box>

                        <FormPageFooter onCancel={ctrl.navigateToList} onSave={ctrl.addOrEditIrp} isSaving={ctrl.isSaving} />
                    </LocalizationProvider>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
